$(document).ready(function () {
    waitForElementToExist('.newsletter-default').then(element => {

        $('#js-form-news').submit(function(event) {
            event.preventDefault();
    
            $('#js-form-news').addClass('form-news-sending')
    
            var data = {
                'email': $(this).find('#email').val()
            }
    
            var action = newsLetter.addEmail(data);
        });
    
        var newsLetter = new NewsLetter();
        var newsLetterBox = $('.modal-newsletter');
        var newsLetterMessage = $('.newsletter__content--message');
        var newsForm = $('.newsletter__form');
    
        $(newsLetter).bind('onSuccessAddEmailNewsLetter', function(event, data) {
            event.preventDefault();
            newsLetterBox.addClass('is-active');
            newsLetterMessage.html('OBRIGADO POR PARTICIPAR, CONFIRA SEU E-MAIL!').addClass('success');
            
            // $('#email').val('').attr('placeholder', 'Email enviado com sucesso').addClass('is-success');
            setTimeout(function() {
                newsLetterBox.removeClass('is-active');
                newsLetterMessage.removeClass('success');
                // $('#email').attr('placeholder', 'Email').removeClass('is-success')
    
                newsForm.removeClass('form-news-sending')
    
            }, 4000);
        }).bind('onFailAddEmailNewsLetter500', function(event, data, jqXHR, textStatus, errorThrown){
            newsLetterBox.addClass('is-active');
            newsLetterMessage.html('<i class="icon-svg-error-close icon-close"></i> O email já está cadastrado!').addClass('error');
            // $('#email').val('').attr('placeholder', 'O email já está cadastrado!').addClass('error');
            setTimeout(function() {
                newsLetterBox.removeClass('is-active');
                newsLetterMessage.removeClass('error');
    
                // $('#email').attr('placeholder', 'Email').removeClass('is-error');
                newsForm.removeClass('form-news-sending')
    
            }, 4000);
            newsLetterBox.addClass('is-active');
            newsLetterMessage.html(data.email[0]).addClass('error');
        }).bind('onFailAddEmailNewsLetter', function(event, data, jqXHR, textStatus, errorThrown){
            event.preventDefault();
            console.log('Error: ', data);
            newsLetterBox.addClass('is-active');
            newsLetterMessage.html('Endereço de e-mail já está cadastrado').addClass('error');
            // $('#email').val('').attr('placeholder', data.email[0]).addClass('is-error');
            setTimeout(function() {
                newsForm.removeClass('form-news-sending')
    
                newsLetterBox.removeClass('is-active');
                setTimeout(function() { newsLetterMessage.removeClass('error') }, 1220 );
    
                $('#email').attr('placeholder', 'Email').removeClass('is-error');
    
            }, 4000);
        });
    });
})